import { Outlet } from '@remix-run/react';
import { AuthGate } from 'platform/components/AuthContext';

export default function AuthLayout(): RouteComponentOutput {
  return (
    <AuthGate>
      <Outlet />
    </AuthGate>
  );
}
